<template>
  <div>
    <div class="notification is-danger" v-if="error" v-html="error.message"></div>
    <div class="notification is-success" v-if="successMsg">{{ successMsg }}</div>
    <div class="field"><textarea ref="commentContent" class="textarea" v-model="comment.content" placeholder="Say something! Add your comment here..." required></textarea></div>
    <div class="field is-grouped" v-if="!commenterSaved">
      <div class="control is-expanded"><input ref="commentName" class="input" v-model="comment.name" type="text" placeholder="Your Name" required></div>
      <div class="control is-expanded"><input ref="commentEmail" class="input" v-model="comment.email" type="email" placeholder="Your Email Address" required></div>
    </div>
    <div class="field" v-if="commenterSaved">
      Commenting as: {{ comment.name }}. <button @click="clearCommenterFromLocalStorage">I'm not {{ comment.name }}</button>
    </div>
    <p class="has-text-right">
      <button class="button button-underline" @click="submitComment">Submit</button>
      <button class="button button-underline cancel" @click="$parent.toggleReply" v-if="$parent.replying">Cancel</button>
    </p>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'comment-form',
  props: ['postId', 'parentId'],
  data () {
    return {
      comment: {
        name: '',
        email: '',
        content: ''
      },
      error: null,
      successMsg: null,
      commenterSaved: false
    }
  },
  mounted () {
    let name = localStorage.getItem('commentName')
    let email = localStorage.getItem('commentEmail')
    if (name || email) this.setCommenterFromLocalStorage(name, email)
  },
  methods: {
    setCommenterFromLocalStorage (name, email) {
      let vm = this
      vm.commenterSaved = true
      if (name) vm.comment.name = name
      if (email) vm.comment.email = email
    },
    clearCommenterFromLocalStorage () {
      this.commenterSaved = false
      this.comment.name = ''
      this.comment.email = ''
      localStorage.removeItem('commentName')
      localStorage.removeItem('commentEmail')
    },
    fetchPost () {
      let vm = this
      // GET /posts => get_single_post() [theme-folder]/api/functions.php
      vm.$axios.get('/posts', {
        params: {
          slug: vm.$route.params.slug
        }
      })
      .then((response) => {
        vm.loading = false
        if (response.data) {
          vm.setCurrentPost(response.data)
          if (vm.$route.hash) vm.scrollToAnchor()
        } else {
          vm.notFound = true
        }
      })
      .catch((err) => {
        vm.loading = false
        vm.notFound = true
        console.log(err)
      })
    },
    submitComment () {
      const vm = this
      // http://v2.wp-api.org/reference/comments/
      vm.$comments.post('/comments', {
        author_name: vm.comment.name,
        author_email: vm.comment.email,
        content: vm.comment.content,
        post: vm.postId,
        parent: vm.parentId
      })
      .then((response) => {
        localStorage.setItem('commentName', vm.comment.name)
        localStorage.setItem('commentEmail', vm.comment.email)
        vm.commenterSaved = true
        vm.comment.content = ''
        vm.error = null
        if (response.data.status === 'hold') {
          vm.successMsg = 'Your comment has been submitted and is pending moderation'
        } else {
          vm.successMsg = 'Your comment has been submitted!'
          vm.fetchPost()
        }
        window.setTimeout(() => {
          vm.successMsg = null
        }, 5000)
      })
      .catch((error) => {
        if (error.response) {
          vm.error = error.response.data
        }
      })
    },
    ...mapActions([
      'setCurrentPost'
    ])
  }
}
</script>

<style lang="sass" scoped>
@import ../../assets/styles/colors
@import ../../assets/styles/mixins

.field
  &.is-grouped
    .control:first-child
      +until($tablet)
        margin-right: 0
        margin-bottom: 0.75em
    +until($tablet)
      display: block
  .input
    height: 40px
  .input, .textarea
    box-shadow: none
    border-radius: 10px
  .textarea
    resize: none
.button-underline
  border-bottom-color: $turqoise
  &.cancel
    margin-left: 20px
    border-bottom-color: #bbb
</style>



// WEBPACK FOOTER //
// CommentForm.vue?4e61240a